import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import * as Languages from 'constants/Language'

class Highlights extends React.Component {
  static propTypes = {
    languageId: React.PropTypes.number.isRequired,
    domain: React.PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.CashbackBannerClick = this.CashbackBannerClick.bind(this)
    this.OpexBannerClick = this.OpexBannerClick.bind(this)
  }

  CashbackBannerClick(link, e) {
    e.preventDefault();
    const { index, activeSlide } = this.props;

    if (index === activeSlide) {
      window.open(
        link,
        'Menu',
        'toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650'
      )
    }
  }

  OpexBannerClick() {
    const { isActiveSlide } = this.props;
    if (isActiveSlide) this.props.push('/bironex')
  }

  render() {
    const { languageId, countryCode } = this.props

    let bannerClass = 'banner-slider__item banner-slider__item--cashback'

    if(languageId === Languages.UZ) {
      bannerClass += ' uz'
    }
    if(languageId === Languages.RU) {
      bannerClass += ' ru'
    }
    if(languageId === Languages.EN) {
      bannerClass += ' en'
    }

    const CashbackBannerClick = this.CashbackBannerClick.bind(
      this,
      '//info.' + this.props.domain + '/promotions'
    )

    return (
      <div className="mute-slider banner-slider">
        <div
          id="banner"
          className={bannerClass}
          onClick={CashbackBannerClick}
        >
          <div className={`money country-${countryCode}`} />
          <div className="label" />
          <div className="message" />
        </div>
      </div>
    )
  }
}

function select(state) {
  const languageId = state.application.get('languageId')
  const domain = state.domain

  return {
    languageId,
    domain,
    user: state.auth.get('user'),
    countryCode: state.application.get('countryCode'),
  }
}

export default connect(select, { push })(Highlights)



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/highlights/Highlights.jsx